import { render, staticRenderFns } from "./AstaSlot.vue?vue&type=template&id=d1aef326&scoped=true&"
import script from "./AstaSlot.vue?vue&type=script&lang=js&"
export * from "./AstaSlot.vue?vue&type=script&lang=js&"
import style0 from "./AstaSlot.vue?vue&type=style&index=0&id=d1aef326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1aef326",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1aef326')) {
      api.createRecord('d1aef326', component.options)
    } else {
      api.reload('d1aef326', component.options)
    }
    module.hot.accept("./AstaSlot.vue?vue&type=template&id=d1aef326&scoped=true&", function () {
      api.rerender('d1aef326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AstaSlot.vue"
export default component.exports